import React, { createContext, useContext, useState } from 'react';
import { ANY_GENRE } from '../utils/libraryFilters';

const ShelfFilterContext = createContext();

// eslint-disable-next-line react-refresh/only-export-components
export const useShelfFilters = () => {
  const context = useContext(ShelfFilterContext);
  if (!context) {
    throw new Error('useShelfFilters must be used within a ShelfFilterProvider');
  }
  return context;
};

export const ShelfFilterProvider = ({ children }) => {
  const [activeContentType, setActiveContentType] = useState('all');
  const [activeStatus, setActiveStatus] = useState('all');
  const [genre, setGenre] = useState(ANY_GENRE);
  const [yearFrom, setYearFrom] = useState('');
  const [yearTo, setYearTo] = useState('');

  const resetFilters = () => {
    setActiveContentType('all');
    setActiveStatus('all');
    setGenre(ANY_GENRE);
    setYearFrom('');
    setYearTo('');
  };

  return (
    <ShelfFilterContext.Provider value={{
      activeContentType,
      setActiveContentType,
      activeStatus,
      setActiveStatus,
      genre,
      setGenre,
      yearFrom,
      setYearFrom,
      yearTo,
      setYearTo,
      resetFilters
    }}>
      {children}
    </ShelfFilterContext.Provider>
  );
};

export default ShelfFilterContext;
